const API_AVAILABLE = 'AVAILABLE';
const API_VALIDATED = 'VALIDATED';
const API_ACTIVATED = 'ACTIVATED';
const API_EDITABLE = 'EDITABLE';
const API_UNAVAILABLE = 'UNAVAILABLE';
const API_NOTYET = 'NOT_YET';
const API_UNEDITABLE = 'UNEDITABLE';
const API_OPTION = 'OPTION';
const API_RESORT_ONLY = 'RESORT_ONLY';
const API_RESORT_ONLY_FORM_SENT = 'RESORT_ONLY_FORM_SENT';
const API_UPSELL_AVAILABLE = 'UPSELL_AVAILABLE';
const API_DONE = 'DONE';

export {
  API_AVAILABLE,
  API_VALIDATED,
  API_ACTIVATED,
  API_EDITABLE,
  API_UNAVAILABLE,
  API_NOTYET,
  API_UNEDITABLE,
  API_OPTION,
  API_RESORT_ONLY,
  API_UPSELL_AVAILABLE,
  API_RESORT_ONLY_FORM_SENT,
  API_DONE,
};
